export default [
    {
        path: '/',
        signal: 'app.homeRouted',
    },
    {
        path: '/:page',
        signal: 'app.pageRouted',
    },
    {
        path: '/:page/:section',
        signal: 'app.sectionRouted',
    },
    {
        path: '/:page/:section/:repeater',
        signal: 'app.repeaterRouted',
    },
];



// WEBPACK FOOTER //
// ./src/store/routes.js